/* eslint-disable react-refresh/only-export-components */
import { lazy, type ReactNode } from "react";
import { Navigate, type RouteObject } from "react-router-dom";
import SettingsLayout from "../../layouts/settings/SettingsLayout";
import { dashboardPath } from "../../config/storefrontRouting";
import { RESOURCE_PERMISSIONS } from "../../permissions/resourcePermissions";
import { useAuth } from "../../permissions/useAuth";
import { useTranslation } from "../../i18n";
import SuspenseWrapper from "../SuspenseWrapper";

const ThemeSettingsPage = lazy(
  () => import("../../pages/settings/ThemeSettingsPage"),
);
const BannerSettingsPage = lazy(
  () => import("../../pages/settings/BannerSettingsPage"),
);
const CommerceSettingsPage = lazy(
  () => import("../../pages/settings/CommerceSettingsPage"),
);
const CompanySettingsPage = lazy(
  () => import("../../pages/settings/CompanySettingsPage"),
);

const suspense = (element: ReactNode) => (
  <SuspenseWrapper>{element}</SuspenseWrapper>
);

function SettingsIndexRedirect() {
  const { isCompanyPrincipal, hasAnyPermission } = useAuth();
  const { t } = useTranslation();
  if (isCompanyPrincipal) {
    return <Navigate to={dashboardPath("/settings/appearance")} replace />;
  }
  if (hasAnyPermission([...RESOURCE_PERMISSIONS.BANNERS])) {
    return <Navigate to={dashboardPath("/settings/banners")} replace />;
  }
  if (hasAnyPermission([...RESOURCE_PERMISSIONS.COMMERCE_SETTINGS])) {
    return <Navigate to={dashboardPath("/settings/commerce")} replace />;
  }
  return <p className="p-6">{t("common.accessDenied")}</p>;
}

export const settingsRoute: RouteObject = {
  path: "settings",
  element: <SettingsLayout />,
  children: [
    {
      index: true,
      element: <SettingsIndexRedirect />,
    },
    { path: "appearance", element: suspense(<ThemeSettingsPage />) },
    { path: "banners", element: suspense(<BannerSettingsPage />) },
    { path: "commerce", element: suspense(<CommerceSettingsPage />) },
    { path: "company", element: suspense(<CompanySettingsPage />) },
  ],
};
